import { render, staticRenderFns } from "./SettingSideBar.vue?vue&type=template&id=652ac68b&"
import script from "./SettingSideBar.vue?vue&type=script&lang=js&"
export * from "./SettingSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports